import { render, staticRenderFns } from "./OpenaiConversationDataTable.vue?vue&type=template&id=2bcf0e1f&scoped=true"
import script from "./OpenaiConversationDataTable.vue?vue&type=script&lang=js"
export * from "./OpenaiConversationDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcf0e1f",
  null
  
)

export default component.exports